import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Data Visualization",
        description: "Turn complex datasets into insightful, interactive visuals.",
        imgUrl: "./img/services/data-analytics/data-visualization.jpg",
    },
    {
        title: "Business Intelligence",
        description: "Empower decision-making with comprehensive dashboards and reporting tools.",
        imgUrl: "./img/services/data-analytics/business-inteligence.jpg",
    },
    {
        title: "Big Data Processing",
        description: "Handle and analyze vast amounts of data efficiently.",
        imgUrl: "./img/services/data-analytics/big-data-processing.png",
    },
    {
        title: "Predictive Analytics",
        description: "Forecast trends and outcomes with advanced statistical models.",
        imgUrl: "./img/services/data-analytics/predictive-analytics.jpg",
    },
    {
        title: "Customer Insights",
        description: "Discover patterns in customer behavior to improve engagement and retention.",
        imgUrl: "./img/services/data-analytics/customer-insights.jpg",
    },
    {
        title: "Real-Time Analytics",
        description: "Monitor live data streams to make immediate, impactful decisions.",
        imgUrl: "./img/services/data-analytics/real-time-analytics.jpg",
    },
];


const DataAnalytics = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "CMS Solutions", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="Data Analytics Solutions" description="Unlock the potential of your data to drive business growth, efficiency, and innovation." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is Data Analytics?</h2>
                            <p>
                                Data Analytics is the process of examining datasets to uncover insights, trends, and actionable information. From descriptive analysis to advanced predictive modeling, it transforms data into a strategic asset.
                            </p>
                            <img
                                src="./img/services/data-analytics.png"
                                alt="Data Analytics"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Benefits of Data Analytics</h2>
                            <ul>
                                <li>Enhance decision-making with accurate insights and forecasts.</li>
                                <li>Identify inefficiencies and optimize processes for greater productivity.</li>
                                <li>Gain a competitive edge with data-driven strategies.</li>
                                <li>Improve customer experience by understanding their needs and preferences.</li>
                                <li>Drive innovation through in-depth trend analysis.</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Take Control of Your Data Today</h2>
                            <p>
                                Discover the power of data analytics for your organization. <br />
                                Contact us at <a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>.
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default DataAnalytics;
